"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionGroup = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
var accordionGroupCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ds-accordion:not(:last-child) {\n    margin-bottom: 8px;\n  }\n"], ["\n  .ds-accordion:not(:last-child) {\n    margin-bottom: 8px;\n  }\n"])));
exports.AccordionGroup = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, showBorder = _a.showBorder, arrowPlacement = _a.arrowPlacement, initialIsOpen = _a.initialIsOpen, rest = __rest(_a, ["children", "showBorder", "arrowPlacement", "initialIsOpen"]);
    return (react_1.default.createElement("div", __assign({ className: (0, css_1.cx)('ds-accordion-group', accordionGroupCss, rest === null || rest === void 0 ? void 0 : rest.className) }, rest, { ref: ref }), react_1.default.Children.map(children, function (child) {
        if (react_1.default.isValidElement(child)) {
            return react_1.default.cloneElement(child, {
                showBorder: showBorder !== null && showBorder !== void 0 ? showBorder : child.props.showBorder,
                arrowPlacement: arrowPlacement !== null && arrowPlacement !== void 0 ? arrowPlacement : child.props.arrowPlacement,
                initialIsOpen: initialIsOpen !== null && initialIsOpen !== void 0 ? initialIsOpen : child.props.initialIsOpen,
            });
        }
        return child;
    })));
});
exports.AccordionGroup.displayName = 'AccordionGroup';
var templateObject_1;
